import React, { useState } from 'react';
import { signUp } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';

const SignUpView = ({
  email, setEmail, password, setPassword,
  setIsNewUser, setMessage
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [hasAcceptedPrivacy, setHasAcceptedPrivacy] = useState(false);
  const [hasAcceptedTerms, setHasAcceptedTerms] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (!email.trim()) {
      setMessage("Please enter your email.");
      return;
    }
    if (!password.trim()) {
      setMessage("Please enter your password.");
      return;
    }
    if (password.length < 8) {
      setMessage("Password must be at least 8 characters long.");
      return;
    }
    
    // ADDED: Privacy policy validation
    if (!hasAcceptedPrivacy) {
      setMessage("Please accept the Privacy Policy to continue.");
      return;
    }
    if (!hasAcceptedTerms) {
      setMessage("Please accept the Terms of Service to continue.");
      return;
    }
  
    try {
      setIsLoading(true);
      setMessage("");
      
      await signUp({
        username: email,
        password,
        options: { 
          userAttributes: { email }
        }
      });
  
      // Store email and password for auto-login after confirmation
      sessionStorage.setItem("pendingEmail", email);
      sessionStorage.setItem("pendingPassword", password);
  
      // Redirect to confirmation page
      navigate('/confirm-email');
    } catch (error) {
      console.error("Sign-up error:", error);
      setMessage(error.message || "An error occurred during sign-up.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-card" id="signupCard">
      <h2 className="signup-title" id="signupTitle">Sign Up</h2>
      
      <div className="signup-form" id="signupForm">
        <div className="signup-form-group" id="signupEmailGroup">
          <label className="signup-label" id="signupEmailLabel">Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            className="signup-input signup-email-input"
            id="signupEmailInput"
            placeholder="Enter your email"
          />
        </div>
        
        <div className="signup-form-group" id="signupPasswordGroup">
          <label className="signup-label" id="signupPasswordLabel">Password</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            className="signup-input signup-password-input"
            id="signupPasswordInput"
            placeholder="Enter your password (min. 8 characters)"
          />
        </div>
        
        {/* ADDED: Privacy Policy and Terms Consent */}
        <div className="signup-consent-section" id="signupConsentSection" style={{ margin: '20px 0', padding: '16px', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', borderRadius: '6px' }}>
          <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', fontWeight: '600', color: '#333' }}>
            Required Consent
          </h4>
          
          <div className="signup-consent-item" id="signupPrivacyConsent" style={{ marginBottom: '12px' }}>
            <label style={{ display: 'flex', alignItems: 'flex-start', cursor: 'pointer', fontSize: '14px', lineHeight: '1.4' }}>
              <input
                type="checkbox"
                checked={hasAcceptedPrivacy}
                onChange={(e) => setHasAcceptedPrivacy(e.target.checked)}
                style={{ marginRight: '8px', marginTop: '2px' }}
                id="privacyPolicyCheckbox"
              />
              <span>
                I have read and agree to the{' '}
                <a 
                  href="https://smack.fm/privacy" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Privacy Policy
                </a>
              </span>
            </label>
          </div>
          
          <div className="signup-consent-item" id="signupTermsConsent">
            <label style={{ display: 'flex', alignItems: 'flex-start', cursor: 'pointer', fontSize: '14px', lineHeight: '1.4' }}>
              <input
                type="checkbox"
                checked={hasAcceptedTerms}
                onChange={(e) => setHasAcceptedTerms(e.target.checked)}
                style={{ marginRight: '8px', marginTop: '2px' }}
                id="termsServiceCheckbox"
              />
              <span>
                I have read and agree to the{' '}
                <a 
                  href="https://smack.fm/terms" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: '#007bff', textDecoration: 'underline' }}
                >
                  Terms of Service
                </a>
              </span>
            </label>
          </div>
        </div>
        
        <button 
          onClick={handleSignUp}
          className={`signup-btn ${isLoading ? 'signup-btn-loading' : ''}`}
          id="signupSubmitBtn"
          disabled={isLoading}
        >
          {isLoading ? "Signing up..." : "Sign Up"}
        </button>
        
        <button 
          onClick={() => setIsNewUser(false)}
          className="signup-switch-btn"
          id="switchToSigninBtn"
        >
          Already have an account? Log In
        </button>
      </div>
    </div>
  );
};

export default SignUpView;